import { Injectable, inject } from '@angular/core';
import {
  ALL_DOCUMENT_CATEGORIES,
  AnyDocument,
  BackBudget,
  BackContract,
  BackHealthRecord,
  BackInvoice,
  BackPAECH,
  BackPayroll,
  BackPdfCalendar,
  Budget,
  Contract,
  DocumentCategory,
  DocumentCategoryTitles,
  HealthRecord,
  Invoice,
  PAECH,
  Payroll,
  PdfCalendar,
} from '@nai-libs/data-access';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class DocumentUtilsService {

  translate = inject(TranslateService);


  parseBudget(backBudget: BackBudget) : Budget {
    return { id: backBudget['offer-number'], ...backBudget, category: 'budget' };
  }
  parseContract(backContract: BackContract) : Contract {
    return { id: backContract['contract-eid'], ...backContract, category: 'contract' };
  }
  parseInvoice(backInvoice: BackInvoice) : Invoice {
    return { id: backInvoice['invoice-eid'], ...backInvoice, category: 'invoice' };
  }
  parsePAECH(backPAECH: BackPAECH) : PAECH {
    return { id: backPAECH.eid, ...backPAECH, category: 'paech' };
  }
  parsePayroll(backPayroll: BackPayroll) : Payroll {
    return { id: backPayroll['payroll-eid'], ...backPayroll, category: 'payroll' };
  }

  parseHealthRecord(backHealthRecord: BackHealthRecord) : HealthRecord {
    return { id: backHealthRecord['record-eid'], ...backHealthRecord, category: 'health-record' };
  }

  parsePdfCalendar(backPdfCalendar: BackPdfCalendar) : PdfCalendar {
    return {...backPdfCalendar, category: 'calendars' };
  }

  isBudget(document: AnyDocument): document is Budget {
    return ((document as Budget).type === 'budget') !== undefined;
  }
  isContract(document: AnyDocument): document is Contract {
    return ((document as Contract).type === 'contract') !== undefined;
  }
  isInvoice(document: AnyDocument): document is Invoice {
    return ((document as Invoice).type === 'invoice') !== undefined;
  }
  isPAECH(document: AnyDocument): document is PAECH {
    return ((document as PAECH).type === 'paech') !== undefined;
  }
  isPayroll(document: AnyDocument): document is Payroll {
    return ((document as Payroll).type === 'payroll') !== undefined;
  }
  isHealthRecord(document: AnyDocument): document is Payroll {
    return ((document as HealthRecord).type === 'health-record') !== undefined;
  }
  isPdfCalendar(document: AnyDocument): document is PdfCalendar {
    return ((document as HealthRecord).type === 'calendars') !== undefined;
  }

  isValidCategory = (category: string): category is DocumentCategory => {
    return ALL_DOCUMENT_CATEGORIES.includes(category as DocumentCategory);
  };

  getCategoryTitle(category: DocumentCategory): string {
    type ObjectKey = keyof typeof DocumentCategoryTitles;
    const categoryKey = category as ObjectKey;
    const title = this.translate.instant(DocumentCategoryTitles[categoryKey]);
    return title || '';
  }
}
